import { clearNotification, showModal } from '@shoflo/studio-redux/actions';
import { REALTIME_CONNECTION_TIMEOUT_VALUE } from '@shoflo/polymer';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/Modal';
import { sendToDatadog } from '@shoflo/polymer';

function lostRealTimeMessage(dispatch, getState) {
  const {
    modal,
    meeting: { attendeeResponse }
  } = getState();

  if (!window.realtimeConnectionLostTimeout) {
    window.realtimeConnectionLostTimeout = setTimeout(() => {
      dispatch(clearNotification());

      if (modal?.type) {
        dispatch(showModal(LOST_REALTIME_SOCKET_CONNECTION, modal.type));
      } else {
        dispatch(showModal(LOST_REALTIME_SOCKET_CONNECTION));
      }
    }, REALTIME_CONNECTION_TIMEOUT_VALUE);
  }

  const payload = {
    attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
  };
  sendToDatadog('socket-dispatcher', payload, 'Realtime connection lost', true);
}

function socketDisconnected({ dispatch, getState }) {
  lostRealTimeMessage(dispatch, getState);
}

export default socketDisconnected;
